import Home from 'modules/Home'
import type { NextPage } from 'next'
import Head from 'next/head';

const HomePage: NextPage = () => {
  return (
    <>
    <Head>
      <title>MyFolio. - React Developer Portfolio</title>
    </Head>
    <Home />
    </>
  );
}
export default HomePage;
